"use strict";

angular.module('PatientApp').controller('MessagesCtrl', ['$stateParams', 'LoadingIndicatorService', 'VueEventTransmitter', 'VuexStore', function ($stateParams, LoadingIndicatorService, VueEventTransmitter, VuexStore) {
  // We just need this logic to live in AngularJS until we port the LoadingIndicatorService.
  // We are still initiating this logic in MessagesContent.vue
  var _loadMessages = function _loadMessages(refreshMessages) {
    _loadingKeyPromise = LoadingIndicatorService.loading();
    VuexStore.dispatch('getMessages', {
      forceFetch: refreshMessages
    }).finally(function () {
      _loadingKeyPromise.then(function (key) {
        LoadingIndicatorService.complete(key);
      });
    });
  },
      _loadingKeyPromise;

  VueEventTransmitter.$on('load-messages', _loadMessages);

  if ($stateParams.autofill) {
    VueEventTransmitter.$emit('message:compose', $stateParams.data);
  }
}]);